import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

const solutions = [
  { name: "Mark All" },
  { name: "Update All" },
  { name: "Delete All" },
];

export const TableActionMenu = () => {
  return (
    <>
      <Popover className="relative">
        <PopoverButton className="inline-flex  gap-x-1   text-gray-900">
          <span>Add Action</span>
        </PopoverButton>

        <PopoverPanel
          transition
          className="absolute z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
        >
          <div className="flex-auto overflow-hidden px-3 bg-white shadow-lg ring-1 ring-gray-900/5">
            <div className="px-4">
              {solutions.map((item) => (
                <div
                  key={item.name}
                  className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50"
                >
                  <div>
                    <div className="cursor-pointer text-gray-900">
                      {item.name}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </PopoverPanel>
      </Popover>
    </>
  );
};
